import { useCallback } from 'react';
import { getIn } from 'formik';
import moment from 'moment';

import type { FormikProps } from 'formik';
import type { Moment } from 'moment';
import type { InsuranceFormValues } from '../../../../types';

export default function useInsuranceDateBounds(formik: FormikProps<InsuranceFormValues>) {
  const insuranceEndBound = getIn(formik.values, 'insurance_end_date');
  const insuranceStartBound = getIn(formik.values, 'insurance_start_date');

  const insuranceStartDisabledDate = useCallback(
    (current?: Moment) =>
      Boolean(
        current &&
          (current.isAfter(moment(), 'day') ||
            (moment.isMoment(insuranceEndBound) && current.isAfter(insuranceEndBound, 'day'))),
      ),
    [insuranceEndBound],
  );
  const insuranceEndDisabledDate = useCallback(
    (current?: Moment) =>
      Boolean(
        current && moment.isMoment(insuranceStartBound) && current.isBefore(insuranceStartBound, 'day'),
      ),
    [insuranceStartBound],
  );

  return { insuranceStartDisabledDate, insuranceEndDisabledDate };
}
